export default __webpack_public_path__ + "static/media/pdf.d709f734.png";